<template>
  <div class="news-container">
    <!-- 新闻标题 -->
    <h1 class="news-title">{{ $t("newsinfo.haiqiao.title") }}</h1>

    <!-- 新闻正文 -->
    <div class="news-content">
      <p class="news-corporation"></p>

      <!-- 第一段 -->
      <p>{{ $t("newsinfo.haiqiao.paragraph1") }}</p>

      <!-- 第一张图片 -->
      <div class="jf-imgborder center">
        <img src="https://www.healthcode.com/media/news/haiqia/1.png" alt="" />
      </div>
      
      <!-- 第二段 -->
      <p>{{ $t("newsinfo.haiqiao.paragraph2") }}</p>

      <!-- 第二张图片 -->
      <div class="jf-imgborder center">
        <img src="https://www.healthcode.com/media/news/haiqia/2.png" alt="" />
      </div>
      
      <!-- 第三张图片 (动态切换) -->
      <div class="jf-imgborder center">
        <img :src="getImagePath('3')" alt="" />
      </div>
      
      <!-- 第四张图片 -->
      <div class="jf-imgborder center">
        <img src="https://www.healthcode.com/media/news/haiqia/4.png" alt="" />
      </div>
      
      <!-- 标题图片 -->
      <div class="jf-imgborder left">
         <img :src="getImagePath('5')" alt="" />
      </div>
      
      <!-- 第三段 -->
    <p v-html="$t('newsinfo.haiqiao.paragraph3')"></p>
      
      <!-- 第四张图片 -->
      <div class="jf-imgborder center">
     <img :src="getImagePath('6')" alt="" />
      </div>
      <div class="jf-imgborder left">
         <img :src="getImagePath('7')" alt="" />
      </div>
      
    <p v-html="$t('newsinfo.haiqiao.paragraph4')"></p>
      
      <!-- 第五张图片 (动态切换) -->
      <div class="jf-imgborder center">
          <img src="https://www.healthcode.com/media/news/haiqia/8.png" alt="" />
      </div>
      <div class="image-caption">
        {{ $t("newsinfo.haiqiao.image8.caption") }}
      </div>
      
      <!-- 第六张图片 (动态切换) -->
      <div class="jf-imgborder center">
    <img src="https://www.healthcode.com/media/news/haiqia/9.png" alt="" />
      </div>
      <div class="image-caption">
        {{ $t("newsinfo.haiqiao.image9.caption") }}
      </div>
      
      <div class="jf-imgborder left">
        <img :src="getImagePath('10')" alt="" />
      </div>
      
      <!-- 第五段 -->
      <p>{{ $t("newsinfo.haiqiao.paragraph5") }}</p>
      
      <!-- 第七张图片 (动态切换) -->
      <div class="jf-imgborder center">
        <img :src="getImagePath('11')" alt="" />
      </div>
      
      <!-- 第八张图片 (动态切换) -->
      <div class="jf-imgborder left">
        <img :src="getImagePath('12')" alt="" />
      </div>
      
      <p>{{ $t("newsinfo.haiqiao.paragraph6") }}</p>
      
      <div class="jf-imgborder center">
        <img src="https://www.healthcode.com/media/news/haiqia/13-1.png" alt="" />
      </div>
      <div class="jf-imgborder center" style="margin-top: 10px;">
        <img src="https://www.healthcode.com/media/news/haiqia/14.png" alt="" />
      </div>

      <!-- 第六段 -->
      <p>{{ $t("newsinfo.haiqiao.paragraph7") }}</p>

      <!-- 第七段 -->
      <p>{{ $t("newsinfo.haiqiao.paragraph8") }}</p>

      <!-- 第九张图片 (动态切换) -->
      <div class="jf-imgborder center">
         <img src="https://www.healthcode.com/media/news/haiqia/15.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, computed, watch } from "vue";
import { useI18n } from "vue-i18n";

const { locale, t } = useI18n();

const currentLang = computed(() => locale.value);

// 根据语言获取图片路径
const getImagePath = (imageName) => {
  const lang = locale.value === 'en' ? '_EN' : '';
  return `https://www.healthcode.com/media/news/haiqia/${imageName}${lang}.png`;
};

const switchLanguage = (lang) => {
  locale.value = lang;
  localStorage.setItem("locale", lang);
};

// 监听语言变化并执行相应操作
watch(locale, (newLocale) => {
  console.log(`语言已切换到：${newLocale}`);
});

// 页面加载后执行的初始化操作
console.log("新闻页面加载完成");
</script>

<style scoped>
body {
  margin: 0;
  padding: 0;
  background-color: #fff;
}
:deep(.highlight-text) {
  font-weight: bold;
  color: #0a74cd; /* 康码品牌蓝色 */
}
.news-container {
  width: 100%;
  max-width: 640px;
  background-color: #fff;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC",
    "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial,
    sans-serif;
  color: #333;
  line-height: 1.6;
  padding: 0 16px;
  box-sizing: border-box;
  position: relative;
  padding-top: 30px;
}

/* 语言切换按钮样式 */
.language-switcher {
  position: fixed;
  top: 10px;
  right: 10px;
  z-index: 1000;
  display: flex;
  gap: 5px;
}

.language-switcher button {
  padding: 8px 12px;
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  cursor: pointer;
  border-radius: 4px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.language-switcher button:hover {
  background-color: #e0e0e0;
}

.language-switcher button.active {
  background-color: #2e3b7a;
  color: white;
  border-color: #2e3b7a;
}

.news-title {
  font-size: 22px;
  font-weight: bold;
  margin: 20px 0 50px 0;
  color: #232323;
  line-height: 1.5;
  margin-top: 120px;
  text-align: center;
}

.news-summary {
  position: relative;
  margin: 0 0 20px;
  padding: 12px 16px;
  background-color: #f8f9fa;
  border-left: 4px solid #e60012;
  color: #666;
  font-size: 16px;
}

.news-summary .left-border {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: #e60012;
}

.news-banner {
  margin: 0 0 20px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.news-banner img {
  width: 100%;
  height: auto;
  display: block;
  transition: transform 0.3s ease;
}

.news-banner img:hover {
  transform: scale(1.02);
}

.news-content {
  margin-bottom: 40px;
  background: #fff;
}

.news-content p {
  margin: 0 0 16px;
  font-size: 17px;
  text-align: justify;
  word-break: break-word;
  line-height: 1.6;
  letter-spacing: 0.034em;
  text-indent: 2em;
}

.news-content .center-title {
  text-align: center !important;
  margin: 24px 0 !important;
  font-size: 18px !important;
  color: #1a1a1a;
}

.jf-imgborder {
  margin: 24px 0 20px 0;
  text-align: center;
}

.jf-imgborder.center {
  text-align: center;
}
.jf-imgborder.left {
  text-align: left;
  margin-top: 60px;
}
.jf-imgborder img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin-bottom: 8px;
}

.image-caption {
  color: #888;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  margin-top: 8px;
  padding: 0 16px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .news-container {
    padding: 80px 12px;
  }

  .news-title {
    font-size: 22px;
    margin: 16px 0 10px;
  }

  .news-content p {
    font-size: 16px;
    margin-bottom: 14px;
  }

  .news-summary {
    padding: 10px 14px;
    font-size: 15px;
  }

  .language-switcher {
    position: static;
    justify-content: flex-end;
    margin-bottom: 10px;
  }
}

@media (max-width: 480px) {
  .news-container {
    padding: 80px 10px;
  }

  .news-title {
    font-size: 20px;
  }

  .news-content p {
    font-size: 15px;
    margin-bottom: 12px;
  }

  .image-caption {
    font-size: 13px;
  }

  .center-title {
    font-size: 16px !important;
  }
}



/* 打印样式 */
@media print {
  .news-container {
    max-width: 100%;
    padding: 0;
  }

  .news-banner {
    box-shadow: none;
  }

  .news-banner img {
    max-height: 300px;
    object-fit: contain;
  }

  .news-content p {
    font-size: 16px;
    line-height: 1.5;
  }

  .language-switcher {
    display: none;
  }
}
</style>
